import { actionTypes } from '../actions/types';

type AppActions = import('../actions/types').AppActions;

export interface KdkReducer {
    showKYC: boolean;
}

export const initialState: KdkReducer = {
    showKYC: true,
};

export const kdkReducer = (state = initialState, action: AppActions = {} as AppActions): KdkReducer => {
    switch (action.type) {
        case actionTypes.FETCH_STATUS_FULFILLED: {
            return {
                ...state,
                showKYC: true,
            };
        }
        case actionTypes.SET_KYC_COMPLETED: {
            return {
                ...state,
                showKYC: false,
            };
        }

        default:
            return state;
    }
};
